import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { API } from 'src/utils/interceptor'

/**
 * The venue's recipes for Cooling chips. Uses the Recipes store when it's
 * already loaded; otherwise one quiet read. A venue without recipe access
 * just gets [] (chips fall back to the shopping list).
 */
const useFoodSafetyRecipes = (venueId, enabled = true) => {
  const stored = useSelector(state => state.recipes?.recipes)
  const hasStored = Array.isArray(stored) && stored.length > 0
  const [fetched, setFetched] = useState({ venueId: null, recipes: [] })

  useEffect(() => {
    if (!enabled || !venueId || hasStored || fetched.venueId === venueId) {
      return undefined
    }
    let cancelled = false
    API.get('api2', `recipes/venue/${venueId}`)
      .then(data => {
        if (!cancelled) {
          setFetched({
            venueId,
            recipes: Array.isArray(data?.recipes) ? data.recipes : [],
          })
        }
        return null
      })
      .catch(() => {
        if (!cancelled) setFetched({ venueId, recipes: [] })
        return null
      })
    return () => {
      cancelled = true
    }
  }, [enabled, venueId, hasStored, fetched.venueId])

  if (hasStored) return stored
  return fetched.venueId === venueId ? fetched.recipes : []
}

export default useFoodSafetyRecipes
